import Axios from 'axios';
import { uniqueId, noop } from 'lodash';

var Storage = /*#__PURE__*/function () {
  function Storage() {
    if (Storage.instance) {
      return Storage.instance;
    }

    Storage.instance = this;
  }

  var _proto = Storage.prototype;

  _proto.get = function get(key) {
    try {
      var value = localStorage.getItem(key);
      return Promise.resolve(value ? JSON.parse(value) : null);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.set = function set(key, value) {
    try {
      localStorage.setItem(key, value ? JSON.stringify(value) : '');
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.remove = function remove(key) {
    try {
      localStorage.removeItem(key);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return Storage;
}();

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DEFAULT_ACCESS_TOKEN_STORAGE_KEY = 'ACCESS_TOKEN';
var DEFAULT_REFRESH_TOKEN_STORAGE_KEY = 'REFRESH_TOKEN';
var DEFAULT_CSRF_TOKEN_STORAGE_KEY = 'csrf_token';
var DEFAULT_KEEP_SIGNEDIN_KEY = 'authenticate/isKeepSignedIn';
var DEFAULT_LOGOUT_TIME_KEY = 'authentication/logoutTime';
var DEFAULT_CONTENT_TYPE_HEADER_KEY = 'Content-Type';
var DEFAULT_CONTENT_TYPE = 'application/json';
var DEFAULT_ACCEPT_HEADER_KEY = 'Accept';
var DEFAULT_ACCEPT = 'application/json';

var Api = /*#__PURE__*/function () {
  function Api(configuration) {
    var _ref,
        _this11 = this;

    var _this = this,
        _this2 = this,
        _this3 = this,
        _this4 = this,
        _this5 = this,
        _this6 = this,
        _this7 = this,
        _this8 = this,
        _this9 = this,
        _this10 = this;

    this.configuration = configuration;
    this.refreshing = false;
    this.queue = [];

    this.refreshToken = function () {
      try {
        return Promise.resolve(_this.getToken(_this.refreshTokenStorageKey).then(function (refreshToken) {
          if (refreshToken && typeof _this.generateRefreshTokenRequest === 'function') return _this.generateRefreshTokenRequest(_this, refreshToken);
          return null;
        }).then(function (response) {
          _this.accessToken = response.data.access_token;
          Promise.all([_this.setToken(_this.accessTokenStorageKey, response.data.access_token), _this.setToken(_this.refreshTokenStorageKey, response.data.refresh_token)]);
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.refreshCsrfToken = function () {
      try {
        console.log('[API] requesting csrf');
        return Promise.resolve(_this2.getToken(_this2.csrfTokenStorageKey).then(function (csrfToken) {
          if (csrfToken && typeof _this2.generateCsrfTokenRequest === 'function') return _this2.generateCsrfTokenRequest(_this2, csrfToken);
          return null;
        }).then(function (response) {
          _this2.csrfToken = response.data.csrf_token;
          Promise.all([_this2.setToken(_this2.csrfTokenStorageKey, response.data.csrf_token)]);
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.get = function (url, params, headers, isPublic) {
      if (params === void 0) {
        params = null;
      }

      if (isPublic === void 0) {
        isPublic = false;
      }

      try {
        return Promise.resolve(_this3.request(url, params, null, 'get', headers, isPublic));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.post = function (url, data, headers, isPublic) {
      if (data === void 0) {
        data = null;
      }

      if (isPublic === void 0) {
        isPublic = false;
      }

      try {
        return Promise.resolve(_this4.request(url, null, data, 'post', headers, isPublic));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.put = function (url, data, headers, isPublic) {
      if (data === void 0) {
        data = null;
      }

      if (isPublic === void 0) {
        isPublic = false;
      }

      try {
        return Promise.resolve(_this5.request(url, null, data, 'put', headers, isPublic));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this["delete"] = function (url, data, headers, isPublic) {
      if (data === void 0) {
        data = null;
      }

      if (isPublic === void 0) {
        isPublic = false;
      }

      try {
        return Promise.resolve(_this6.request(url, null, data, 'delete', headers, isPublic));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.request = function (url, params, data, method, headers, isPublic, configuration) {
      if (isPublic === void 0) {
        isPublic = false;
      }

      if (configuration === void 0) {
        configuration = {};
      }

      try {
        if (!_this7.axios) {
          throw Error('[API] Api module has not initialized');
        }

        var requestConfig = _extends({
          method: method,
          url: url,
          params: params,
          data: data,
          headers: _extends({}, _this7.configuration.headers, headers),
          isPublic: isPublic
        }, configuration);

        return Promise.resolve(_this7.axios(requestConfig));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.signIn = function (credentials) {
      try {
        if (typeof _this8.generateSignInRequest === 'function') {
          return Promise.resolve(_this8.generateSignInRequest(_this8, credentials).then(function (response) {
            _this8.accessToken = response.data.access_token;
            var now = new Date();
            return Promise.all([_this8.setToken(_this8.accessTokenStorageKey, response.data.access_token), _this8.setToken(_this8.refreshTokenStorageKey, response.data.refresh_token), _this8.setToken(_this8.logoutTimeKey, response.data.token_lifetime), _this8.setToken(_this8.keepSignedInKey, now.getTime() + response.data.token_lifetime)]).then(_this8.onSignedIn);
          }));
        }

        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.signOut = function () {
      try {
        console.log('[API] signing user out.');

        if (typeof _this9.generateSignOutRequest === 'function') {
          return Promise.resolve(_this9.generateSignOutRequest(_this9)["finally"](function () {
            _this9.accessToken = undefined;
            return Promise.all([_this9.removeToken(_this9.accessTokenStorageKey), _this9.removeToken(_this9.refreshTokenStorageKey)]).then(_this9.onSignedOut);
          }));
        }

        _this9.accessToken = undefined;
        return Promise.all([_this9.removeToken(_this9.accessTokenStorageKey), _this9.removeToken(_this9.refreshTokenStorageKey)]).then(_this9.onSignedOut);
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.onSignedIn = noop;
    this.onSignedOut = noop;

    this.shouldRefreshTokensOnError = function (error) {
      return error.code === 403;
    };

    this.shouldSignOutOnError = function (error) {
      return error.code === 401;
    };

    this.customErrorHandler = noop;
    this.handleSignout = noop;

    this.authenticated = function () {
      try {
        return Promise.resolve(_this10.getToken(_this10.configuration.refreshTokenStorageKey || DEFAULT_REFRESH_TOKEN_STORAGE_KEY).then(function (token) {
          return !!token;
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    if (Api.instance) {
      return Api.instance;
    }

    Api.instance = this;

    var storage = configuration.storage,
        _configuration$debug = configuration.debug,
        debug = _configuration$debug === void 0 ? false : _configuration$debug,
        _configuration$defaul = configuration.defaultHeaders,
        defaultHeaders = _configuration$defaul === void 0 ? true : _configuration$defaul,
        _configuration$access = configuration.accessTokenStorageKey,
        accessTokenStorageKey = _configuration$access === void 0 ? DEFAULT_ACCESS_TOKEN_STORAGE_KEY : _configuration$access,
        _configuration$refres = configuration.refreshTokenStorageKey,
        refreshTokenStorageKey = _configuration$refres === void 0 ? DEFAULT_REFRESH_TOKEN_STORAGE_KEY : _configuration$refres,
        _configuration$csrfTo = configuration.csrfTokenStorageKey,
        csrfTokenStorageKey = _configuration$csrfTo === void 0 ? DEFAULT_CSRF_TOKEN_STORAGE_KEY : _configuration$csrfTo,
        _configuration$keepSi = configuration.keepSignedInKey,
        keepSignedInKey = _configuration$keepSi === void 0 ? DEFAULT_KEEP_SIGNEDIN_KEY : _configuration$keepSi,
        _configuration$logout = configuration.logoutTimeKey,
        logoutTimeKey = _configuration$logout === void 0 ? DEFAULT_LOGOUT_TIME_KEY : _configuration$logout,
        axiosConfiguration = _objectWithoutPropertiesLoose(configuration, ["storage", "debug", "defaultHeaders", "accessTokenStorageKey", "refreshTokenStorageKey", "csrfTokenStorageKey", "authenticationHeaderKey", "keepSignedInKey", "logoutTimeKey"]);

    this.axios = Axios.create(_extends({}, axiosConfiguration, {
      headers: _extends({}, axiosConfiguration.headers, defaultHeaders ? (_ref = {}, _ref[DEFAULT_CONTENT_TYPE_HEADER_KEY] = DEFAULT_CONTENT_TYPE, _ref[DEFAULT_ACCEPT_HEADER_KEY] = DEFAULT_ACCEPT, _ref) : {})
    }));
    this.storage = storage;
    this.debug = debug;
    this.accessTokenStorageKey = accessTokenStorageKey;
    this.refreshTokenStorageKey = refreshTokenStorageKey;
    this.csrfTokenStorageKey = csrfTokenStorageKey;
    this.keepSignedInKey = keepSignedInKey;
    this.logoutTimeKey = logoutTimeKey;
    this.getToken(this.accessTokenStorageKey).then(function (accessToken) {
      if (typeof accessToken === 'string') {
        _this11.accessToken = accessToken;
      }
    });
    this.axios.interceptors.request.use(function (requestConfiguration) {
      if (_this11.accessToken) {
        var requestConfigWithAccessToken = _extends({}, requestConfiguration, {
          headers: _extends({}, requestConfiguration.headers, {
            'x-csrf-token': _this11.csrfToken
          })
        });

        if (_this11.debug) _this11.logRequest(requestConfigWithAccessToken);
        return requestConfigWithAccessToken;
      } else {
        var _requestConfigWithAccessToken = _extends({}, requestConfiguration, {
          headers: _extends({}, requestConfiguration.headers, {
            'x-csrf-token': _this11.csrfToken
          })
        });

        if (_this11.debug) _this11.logRequest(_requestConfigWithAccessToken);
        return _requestConfigWithAccessToken;
      }
    }, function (error) {
      return Promise.reject(error);
    });
    this.axios.interceptors.response.use(function (response) {
      if (_this11.debug) _this11.logResponse(response);
      return response.data;
    }, function (error) {
      var formattedError = _this11.formatError(error);

      var requestConfiguration = formattedError.request;
      var wasPublic = (requestConfiguration === null || requestConfiguration === void 0 ? void 0 : requestConfiguration.isPublic) || false;
      if (_this11.debug) _this11.logError(formattedError);

      if (_this11.shouldSignOutOnError(error)) {
        return Promise.reject(formattedError);
      } else if (!wasPublic && _this11.shouldRefreshTokensOnError(formattedError)) {
        if (_this11.refreshing && (formattedError.status === 401 || formattedError.status === 403)) {
          return Promise.reject(formattedError);
        }

        if (!_this11.refreshing) {
          _this11.refreshing = true;

          _this11.refreshCsrfToken().then(function () {
            if (formattedError.status === 401) {
              _this11.refreshToken().then(function () {
                return _this11.getToken(_this11.accessTokenStorageKey);
              }).then(function (token) {
                _this11.refreshing = false;

                _this11.queue.map(function (request) {
                  return request.executeWith(token);
                });

                _this11.queue = [];
              })["catch"](function () {
                _this11.refreshing = false;

                if (typeof _this11.handleSignout === 'function') {
                  console.log('[API] sending user to signout page due to refresh token failure.');

                  _this11.handleSignout();
                }

                return Promise.reject(formattedError);
              });
            } else {
              _this11.refreshing = false;

              _this11.queue.map(function (request) {
                return request.executeWith(_this11.getToken(_this11.accessTokenStorageKey));
              });

              _this11.queue = [];
            }
          });
        }

        return new Promise(function (resolve, reject) {
          var request = {
            executeWith: function executeWith() {
              resolve(_this11.axios(requestConfiguration));
            },
            reject: reject
          };

          _this11.queue.push(request);
        });
      }

      return Promise.reject(formattedError);
    });
  }

  var _proto = Api.prototype;

  _proto.formatError = function formatError(error) {
    var _response$data;

    var requestConfiguration = error.config;
    var response = error.response;
    var status = (response === null || response === void 0 ? void 0 : response.status) || 0;
    var data = ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) || response.data;
    var message = Array.isArray(data) ? data.reduce(function (message, chunk) {
      return message + ' ' + (chunk === null || chunk === void 0 ? void 0 : chunk.message) || '';
    }, '') : (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : data.error) || 'Unknown';
    var formattedError = {
      key: uniqueId('error'),
      status: status,
      message: message,
      data: data,
      request: requestConfiguration
    };
    return formattedError;
  };

  _proto.setToken = function setToken(key, token) {
    try {
      var _this13 = this;

      if (_this13.storage && typeof _this13.storage.set === 'function') {
        return Promise.resolve(_this13.storage.set(key, token));
      }

      console.error('[API]', 'Could not save token.');
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getToken = function getToken(key) {
    try {
      var _exit2 = false;

      var _this15 = this;

      var _temp3 = function _temp3(_result) {
        if (_exit2) return _result;
        console.error('[API]', 'Could not load token.');
        return undefined;
      };

      var _temp4 = function () {
        if (_this15.storage && typeof _this15.storage.get === 'function') {
          return Promise.resolve(_this15.storage.get(key)).then(function (token) {
            _exit2 = true;
            return token;
          });
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.removeToken = function removeToken(key) {
    try {
      var _this17 = this;

      if (_this17.storage && typeof _this17.storage.remove === 'function') {
        return Promise.resolve(_this17.storage.remove(key));
      }

      console.error('[API]', 'Could not delete token.');
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.logRequest = function logRequest(request) {
    console.log("%c[REQUEST] " + (request.method || '').toUpperCase() + " " + request.url, 'font-weight: bold;');
    console.log(request);
  };

  _proto.logResponse = function logResponse(response) {
    var _response$config;

    console.log("%c[RESPONSE] " + (((_response$config = response.config) === null || _response$config === void 0 ? void 0 : _response$config.method) || '').toUpperCase() + " " + response.config.url, 'font-weight: bold;');
    console.log(response);
  };

  _proto.logError = function logError(error) {
    console.log("%c[API ERROR] " + error.status + ": " + error.message, 'color: red; font-weight: bold;');
    console.log('[ERROR DATA]', error.data);
    console.log('[ERROR REQUEST]', error.request);

    if (typeof this.customErrorHandler === 'function') {
      this.customErrorHandler(error);
    }
  };

  _proto.setCsrfToken = function setCsrfToken(token) {
    this.csrfToken = token;
  };

  return Api;
}();

export { Api, Storage };
//# sourceMappingURL=index.modern.js.map
